export default __webpack_public_path__ + "static/gilroy-light-fd31e79c873a0f24aa5659d2a47d3646.ttf";